import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconInsurance = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Insurance'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 3 34 41' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M41.5 -2H39.5V0H41.5V-2ZM11.025 23.975C12.375 25.3251 14.0333 26 16 26C17.9667 26 19.625 25.3251 20.975 23.975C22.325 22.625 23 20.9667 23 19C23 17.0334 22.325 15.375 20.975 14.025C19.625 12.675 17.9667 12 16 12C14.0333 12 12.375 12.675 11.025 14.025C9.675 15.375 9 17.0334 9 19C9 20.9667 9.675 22.625 11.025 23.975ZM18.15 21.15C17.5833 21.7167 16.8667 22 16 22C15.1333 22 14.4167 21.7167 13.85 21.15C13.2833 20.5834 13 19.8667 13 19C13 18.1334 13.2833 17.4167 13.85 16.85C14.4167 16.2834 15.1333 16 16 16C16.8667 16 17.5833 16.2834 18.15 16.85C18.7167 17.4167 19 18.1334 19 19C19 19.8667 18.7167 20.5834 18.15 21.15ZM4 12.75L16 8.25005L28 12.75V22.2C28 24 27.75 25.75 27.25 27.45C26.75 29.15 26.0667 30.75 25.2 32.25C23.8 31.55 22.3333 31 20.8 30.6001C19.2667 30.2001 17.6667 30 16 30C14.3333 30 12.7333 30.2001 11.2 30.6001C9.66667 31 8.2 31.55 6.8 32.25C5.93333 30.75 5.25 29.15 4.75 27.45C4.25 25.75 4 24 4 22.2V12.75ZM12.5 34.4C13.6333 34.1334 14.8 34 16 34C17.2 34 18.3667 34.1334 19.5 34.4C20.6333 34.6667 21.7167 35.0334 22.75 35.5C21.7833 36.5 20.7333 37.3667 19.6 38.1C18.4667 38.8334 17.2667 39.4 16 39.8C14.7333 39.4 13.5333 38.8334 12.4 38.1C11.2667 37.3667 10.2167 36.5 9.25 35.5C10.2833 35.0334 11.3667 34.6667 12.5 34.4ZM15.35 43.75C15.55 43.7834 15.7667 43.8 16 43.8C16.2333 43.8 16.45 43.7834 16.65 43.75C16.85 43.7167 17.05 43.6667 17.25 43.6C21.75 42.1 25.3333 39.3251 28 35.275C30.6667 31.225 32 26.8667 32 22.2V12.75C32 11.9167 31.7583 11.1667 31.275 10.5C30.7917 9.83338 30.1667 9.35005 29.4 9.05005L17.4 4.55005C16.9333 4.38338 16.4667 4.30005 16 4.30005C15.5333 4.30005 15.0667 4.38338 14.6 4.55005L2.6 9.05005C1.83333 9.35005 1.20833 9.83338 0.725 10.5C0.241667 11.1667 0 11.9167 0 12.75V22.2C0 26.8667 1.33333 31.225 4 35.275C6.66667 39.3251 10.25 42.1 14.75 43.6C14.95 43.6667 15.15 43.7167 15.35 43.75Z"
      />
    </Icon>
  )
}

IconInsurance.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconInsurance
